(function ($) {
    $('.ba_top_banner_close').on('click', closeTopBanner);

    function closeTopBanner(e) {
        if (!window.ba_top_banner || !window.ba_top_banner.body_classes) {
            return;
        }
        var body = $('body');
        for (var i = 0; i < window.ba_top_banner.body_classes.length; i++) {
            body.removeClass(window.ba_top_banner.body_classes[i]);
        }
        body.removeClass('has-banner-top-banner');
        var banner = $(e.target).closest('.ba_top_banner');
        body.find('.ba_top_banner_placeholder').remove();
        banner.remove();
        $('#ba-top-banner-css').remove();
        if (window.ba_top_banner.ls_key) {
            localStorage.setItem(window.ba_top_banner.ls_key, true);
        }
        if (window.ba_top_banner.clockInterval) {
            clearInterval(window.ba_top_banner.clockInterval);
        }
    }

    window.startBaCountdown = function (banner) {
        var $banner = $('#' + banner.css_id);
        var $timer = $banner.find('[data-is-clock="true"]');
        if (!$timer.length) {
            return null;
        }
        var hours = $timer.find('.ba-clock-hours').find('.ba-clock-number').get(0);
        var minutes = $timer.find('.ba-clock-minutes').find('.ba-clock-number').get(0);
        var seconds = $timer.find('.ba-clock-seconds').find('.ba-clock-number').get(0);

        setBannerEndTime();
        var initialTime = getTimeRemaining(banner.end_time_ms);

        if (initialTime.total < 0) {
            setCountdownAtZero();
            return;
        }

        clockTick();

        $timer.addClass('countdown-has-started');

        function setCountdownAtZero() {
            hours.innerText = '00';
            minutes.innerText = '00';
            seconds.innerText = '00';
        }

        function clockTick() {
            var time = getTimeRemaining(banner.end_time_ms);
            if (time.total < 0) {
                stopCountdown();
                return;
            }
            if (hours.innerText !== String(time.hours)) {
                if (time.hours < 10) {
                    time.hours = '0' + String(time.hours);
                }
                hours.innerText = time.hours;
            }
            if (minutes.innerText !== String(time.minutes)) {
                if (time.minutes < 10) {
                    time.minutes = '0' + String(time.minutes);
                }
                minutes.innerText = time.minutes;
            }
            if (time.seconds < 10) {
                time.seconds = '0' + String(time.seconds);
            }
            seconds.innerText = time.seconds;
        }

        banner.clockInterval = setInterval(clockTick, 1000);

        function stopCountdown() {
            setCountdownAtZero();
            clearInterval(banner.clockInterval);
            banner.ls_key = null;
            $banner.find('.ba_top_banner_close').trigger('click');
        }

        function getTimeRemaining(endtime) {
            var total = endtime - Date.parse(new Date());
            var seconds = Math.floor((total / 1000) % 60);
            var minutes = Math.floor((total / 1000 / 60) % 60);
            var hours = Math.floor(total / (1000 * 60 * 60));

            return {
                total: total,
                seconds: seconds,
                minutes: minutes,
                hours: hours
            };
        }

        function setBannerEndTime() {
            banner.end_time_ms = banner.end_time * 1000;
            if ($timer.data('countdown-to') === 'daily') {
                var total_time_left = banner.end_time_ms - Date.parse(new Date());
                var days_left = total_time_left / (1000 * 60 * 60 * 24);
                if (days_left > 1) {
                    banner.end_time_ms -= 1000 * 60 * 60 * 24 * Math.floor(days_left);
                }
            }
        }
    }
    window.startBaCountdown(ba_top_banner);
})(ba_essentials.$ || jQuery);